import { Checkbox, CheckboxProps } from 'antd';

export interface QmbEligibilityComponentProps {
  value?: boolean;
  onChange?: (checked: boolean) => void;
}

export const QmbEligibilityComponent = ({
  value,
  onChange,
}: QmbEligibilityComponentProps) => {
  const handleChange: CheckboxProps['onChange'] = (e) => {
    const { checked } = e.target;
    onChange?.(checked);
  };

  return (
    <Checkbox
      checked={!!value}
      onChange={handleChange}
    >
      <div className="flex gap0 ai-c">
        <span>
          QMB (Qualified Medicare Beneficiary) Eligible
        </span>
      </div>
    </Checkbox>
  );
};
